import Tariffs from './Tariffs';

export default Tariffs;
